import React, { useCallback, useContext } from 'react';
import { Button } from '@mui/material';
import { useDataProvider, useNotify, useRedirect } from 'react-admin';
import { useMutation } from '@tanstack/react-query';

import ButtonGroup from '../../ButtonGroup';
import SwitchLoginMethods from '../SwitchLoginMethods';
import LoginContext from '../LoginContext';
import useNextPath from '../../../../hooks/useNextPath';

type StartSsoResponse = {
  context: string;
};

const SSOPage = () => {
  const redirect = useRedirect();
  const notify = useNotify();
  const dataProvider = useDataProvider();
  const loginContext = useContext(LoginContext);

  const redirectTo = useNextPath();

  const {
    mutateAsync: startSso,
  } = useMutation({
    mutationFn: async (data: {
      alias: string;
      redirectTo: string | undefined;
    }): Promise<StartSsoResponse> => {
      const res = await dataProvider.create('auth/start-sso', {
        data: { alias: data.alias, redirectTo: data.redirectTo },
      });
      return res.data;
    },
  });

  const ssoLogin = useCallback(async () => {
    if (!loginContext) return;
    const { accountDetails } = loginContext;
    if (!accountDetails) return;
    const { alias } = accountDetails;

    try {
      const data = await startSso({ alias, redirectTo });
      redirect(data.context);
    } catch (error: any) {
      notify(error.message, { type: 'error' });
    }
  }, [notify, redirect, startSso, loginContext, redirectTo]);

  return (
    <ButtonGroup sx={{ mt: 6 }}>
      <Button
        variant="contained"
        onClick={ssoLogin}
      >
        Sign in with SSO
      </Button>
      <SwitchLoginMethods />
    </ButtonGroup>
  );
};

export default SSOPage;
